<template>
  <div ref="containerRef" class="gif-container">
    <img v-show="!isGifImageHovered" :src="staticImageSrc" />
    <img v-show="isGifImageHovered" :src="originalImageSrc" />
    <span v-show="showTag" class="gif-tag">GIF</span>
  </div>
</template>

<script setup lang="ts">
import { useElementHover } from "@vueuse/core";
const props = defineProps({
  src: {
    type: String,
    required: true,
  },
  showTag: {
    type: Boolean,
    default: true,
  },
  ImageSize: {
    type: Number,
    default: ImageSize.Collection,
  },
});
const containerRef = ref(null);
const isGifImageHovered = useElementHover(containerRef);
const staticImageSrc = computed(
  () =>
    `${props.src}&width=${props.ImageSize}&height=${props.ImageSize}&keepStatic=true`
);
const originalImageSrc = computed(
  () =>
    `${props.src}&width=${props.ImageSize / 2}&height=${
      props.ImageSize / 2
    }&keepStatic=false`
);
</script>

<style lang="scss" scoped>
.gif-container {
  @apply relative w-full h-full;

  img {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    transform: scale(1) !important;
  }
}

.gif-tag {
  backdrop-filter: blur(4px);
  z-index: 1;
  width: 40px;
  height: 24px;
  flex-shrink: 0;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.15);
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  @apply absolute right-8px bottom-8px  text-align-center;
}
</style>
